module.exports = __webpack_public_path__ + "static/media/editor-icon-text-style.257da663.svg";